import React from "react";

import {
  Map1,
  Map2,
  Map3,
  Map4,
  Map5,
  Map6,
  Map7,
  Map8,
  Map9,
  Map10,
  Map12,
  Map13,
  Map14,
  Map15,
  Map16,
  Map17,
  Map18,
  Map19,
  Map20,
  Map21,
  Map22,
  Map23,
  Map24,
  Map25,
  Map26,
  Map27,
  Map28,
  Map29,
  Map30,
  Map31,
  Map32,
  Map33,
  Map34,
  Map35,
  Map36,
  Map37,
  Map38,
  Map39,
  Map40,
  Map41,
  Map42,
  Map43,
  Map44,
  Map45,
  Map46,
  Map47,
  Map48,
  Map49,
  Map50,
  Map51,
  Map52,
  Map53,
  Map54,
  Map55,
  Map56,
  Map57,
  Map58,
  Map59,
  Map61,
  Map62,
  Map63,
  Map64,
  Map65,
  Map66,
  Map67,
  Map68,
  Map69,
  Map70,
  Map71,
  Map72,
  Map73,
  Map74,
  Map76,
  Map77,
  Map78,
  Map79,
  Map80,
  Map81,
  Map82,
  Map83,
  Map85,
  Map86,
  Map87,
  Map88,
  Map89,
  Map90,
  Map92,
  Map93,
  Map94,
  Map95,
  Map96,
  Map97,
  Map98,
  Map99,
  Map100,
  Map101,
  Map102,
  Map103,
  Map104,
  Map105,
  Map109,
  Map110,
} from "../../assets";

const svgsMap = {
  1: Map1,
  2: Map2,
  3: Map3,
  4: Map4,
  5: Map5,
  6: Map6,
  7: Map7,
  8: Map8,
  9: Map9,
  10: Map10,
  12: Map12,
  13: Map13,
  14: Map14,
  15: Map15,
  16: Map16,
  17: Map17,
  18: Map18,
  19: Map19,
  20: Map20,
  21: Map21,
  22: Map22,
  23: Map23,
  24: Map24,
  25: Map25,
  26: Map26,
  27: Map27,
  28: Map28,
  29: Map29,
  30: Map30,
  31: Map31,
  32: Map32,
  33: Map33,
  34: Map34,
  35: Map35,
  36: Map36,
  37: Map37,
  38: Map38,
  39: Map39,
  40: Map40,
  41: Map41,
  42: Map42,
  43: Map43,
  44: Map44,
  45: Map45,
  46: Map46,
  47: Map47,
  48: Map48,
  49: Map49,
  50: Map50,
  51: Map51,
  52: Map52,
  53: Map53,
  54: Map54,
  55: Map55,
  56: Map56,
  57: Map57,
  58: Map58,
  59: Map59,
  61: Map61,
  62: Map62,
  63: Map63,
  64: Map64,
  65: Map65,
  66: Map66,
  67: Map67,
  68: Map68,
  69: Map69,
  70: Map70,
  71: Map71,
  72: Map72,
  73: Map73,
  74: Map74,
  76: Map76,
  77: Map77,
  78: Map78,
  79: Map79,
  80: Map80,
  81: Map81,
  82: Map82,
  83: Map83,
  85: Map85,
  86: Map86,
  87: Map87,
  88: Map88,
  89: Map89,
  90: Map90,
  92: Map92,
  93: Map93,
  94: Map94,
  95: Map95,
  96: Map96,
  97: Map97,
  98: Map98,
  99: Map99,
  100: Map100,
  101: Map101,
  102: Map102,
  103: Map103,
  104: Map104,
  105: Map105,
  109: Map109,
  110: Map110,
};

const MapCommune = ({ id }) => {
  const SvgComponent = svgsMap[id];
  return (
    <div className="w-153 flex items-center" id="commune-map">
      <SvgComponent style={{ width: "100%", height: "auto" }} />
    </div>
  );
};

export default MapCommune;
